<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Shop URL</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="shopUrl"
                @input="onUpdate"
            />
        </div>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Admin Access Token</div>
            </div>
            <input
                type="password"
                class="form-control"
                required
                v-model="adminAccessToken"
                @input="onUpdate"
            />
        </div>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Private Access Token</div>
            </div>
            <input
                type="password"
                class="form-control"
                required
                v-model="privateAccessToken"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Secret Key</div>
            </div>
            <input
                type="password"
                class="form-control"
                required
                v-model="secretKey"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: CheckoutOrderId</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCheckoutOrderId"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const shopUrl = ref(null);
const adminAccessToken = ref(null);
const privateAccessToken = ref(null);
const secretKey = ref(null);
const fieldCheckoutOrderId = ref(null);
const serializedValue = computed(() => {
  return {
    shop_url: shopUrl.value,
    admin_access_token: adminAccessToken.value,
    private_access_token: privateAccessToken.value,
    secret_key: secretKey.value,
    field_checkout_order_id: fieldCheckoutOrderId.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    shopUrl.value = modelValue.value.shop_url;
    adminAccessToken.value = modelValue.value.admin_access_token;
    privateAccessToken.value = modelValue.value.private_access_token;
    secretKey.value = modelValue.value.secret_key;
    fieldCheckoutOrderId.value = modelValue.value.field_checkout_order_id;
    if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
      onUpdate();
    }
  }
}, {
  immediate: true
});
</script>
